<template>
  <div>
    <div v-if="painel.ativo">
      <audio ref="audioElement" src="@/assets/audios/alerta1.mp3" muted></audio>
      <div class="row" v-show="chamando">
        <div
          class="d-flex justify-content-center align-items-center p-1"
          :style="
            'width: 100%; height: 100%; background:' +
            painel.cor_card +
            '; flex-direction: column;'
          "
        >
          <span
            :style="
              'color:' +
              painel.cor_primaria +
              ';   font-size: 16vh;  line-height: 18vh;'
            "
            >Senha</span
          ><br />
          <span
            :style="
              'color:' +
              painel.cor_secundaria +
              '; font-size: 28vh; line-height: 20vh;'
            "
            v-if="senhas[0]"
            >{{ senhas[0].prefixo
            }}<span :style="'color:' + painel.cor_primaria + ';'">{{
              senhas[0].senha
            }}</span></span
          ><br />
          <span
            :style="
              'color:' +
              painel.cor_primaria +
              ';   font-size: 15vh;  line-height: 17vh;'
            "
            >Local</span
          ><br />
          <span
            :style="
              'color:' +
              painel.cor_primaria +
              ';   font-size: 13vh;  line-height: 12vh;'
            "
            v-if="senhas[0]"
            >{{ senhas[0].local }}</span
          ><br />
          <span
            :style="
              'color:' +
              painel.cor_primaria +
              ';   font-size: 5vh;  line-height: 6vh;'
            "
            v-if="senhas[0] && senhas[0].pessoa && painel.mostra_pessoa"
            >{{ senhas[0].pessoa }}</span
          ><br />
        </div>
      </div>
      <div class="row" v-show="!chamando">
        <div
          class="col-md-12 px-3 py-2"
          :style="
            'font-family: helvetica; height: 100vh; background: radial-gradient(' +
            painel.background +
            ', #000000); display: flex;flex-wrap: wrap;'
          "
        >
          <div
            :style="
              'width: 62%; height: 84%; background:' +
              painel.cor_card +
              '; border-radius:' +
              painel.arredondamento +
              'px; margin-right: 1.5%;'
            "
            v-show="!painel.video"
          >
            <div
              class="d-flex justify-content-center align-items-center"
              style="flex-direction: column; height: 100%; padding: 2vh"
            >
              <span
                :style="
                  'color:' +
                  painel.cor_primaria +
                  '; font-size: ' +
                  painel.fonte * 0.4 +
                  'vh; line-height: ' +
                  painel.fonte * 0.4 +
                  'vh; font-weight: 600;'
                "
                >Senha</span
              ><br />
              <span
                :style="
                  'color:' +
                  painel.cor_secundaria +
                  '; font-size: ' +
                  painel.fonte +
                  'vh; line-height: ' +
                  painel.fonte +
                  'vh; font-weight: 700;'
                "
                v-if="senhas[0]"
              >
                {{ senhas[0].prefixo
                }}<span :style="'color:' + painel.cor_primaria + ';'">{{
                  senhas[0].senha
                }}</span> </span
              ><br />
              <span
                :style="
                  'color:' +
                  painel.cor_primaria +
                  '; font-size: ' +
                  painel.fonte * 0.4 +
                  'vh; line-height: ' +
                  painel.fonte * 0.4 +
                  'vh; font-weight: 600; margin-top: 2vh;'
                "
                >Local</span
              ><br />
              <span
                :style="
                  'color:' +
                  painel.cor_primaria +
                  '; font-size: ' +
                  painel.fonte * 0.53 +
                  'vh; line-height: ' +
                  painel.fonte * 0.53 +
                  'vh; font-weight: 600; text-align: center; max-width: 95%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;'
                "
                v-if="senhas[0]"
                >{{ senhas[0].local }}</span
              ><br />
              <span
                :style="
                  'color:' +
                  painel.cor_primaria +
                  '; font-size: ' +
                  painel.fonte * 0.33 +
                  'vh; line-height: ' +
                  painel.fonte * 0.33 +
                  'vh; font-weight: 500; text-align: center; max-width: 95%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-top: 2vh;'
                "
                v-if="senhas[0] && senhas[0].pessoa && painel.mostra_pessoa"
              >
                {{ senhas[0].pessoa }} </span
              ><br />
            </div>
          </div>
          <div
            :style="
              'width: 62%; height: 84%; background: #000000;' +
              'border-radius:' +
              painel.arredondamento +
              'px; margin-right: 1.5%;'
            "
            v-show="painel.video"
          >
            <div
              class="d-flex justify-content-center align-items-center"
              style="flex-direction: column; height: 100%"
            >
              <!-- Video originado do servidor local -->
              <video
                :src="'http://localhost:3000/video/' + painel.video_unidade.id"
                v-if="video_server_online"
                width="100%"
                autoplay
                muted
                loop
              ></video>
              <!-- Caso o servidor local não funcione, utilize o video do servidor cloud -->
              <video
                :src="
                  painel.video_unidade ? painel.video_unidade.video_link : ''
                "
                v-else
                width="100%"
                autoplay
                muted
                loop
              ></video>
            </div>
          </div>
          <div
            class="d-flex text-center p-0"
            :style="
              'width: 36.5%; height: 84%; color: ' +
              painel.cor_primaria +
              '; background:' +
              painel.cor_card +
              '; border-radius:' +
              painel.arredondamento +
              'px; flex-direction: column;'
            "
          >
            <div
              class="p-0 d-flex align-items-center justify-content-center"
              :style="
                'padding: 2vh 0; font-weight: 700; font-size: ' +
                painel.fonte * 0.21 +
                'vh; border-bottom: 2px solid #000; color: ' +
                painel.cor_primaria
              "
            >
              Últimas Chamadas
            </div>
            <div
              class="d-flex flex-column align-items-center justify-content-center"
              v-for="(senha, index) in senhas"
              :key="senha + index + ''"
              style="
                flex: 1;
                padding: 1vh 1vh;
                border-top: 1px solid #000;
                min-height: 0;
              "
            >
              <div
                :style="
                  'color:' +
                  painel.cor_secundaria +
                  '; font-size: ' +
                  painel.fonte * 0.23 +
                  'vh; line-height: ' +
                  painel.fonte * 0.23 +
                  'vh; font-weight: 600;'
                "
              >
                {{ senha.prefixo
                }}<span :style="'color:' + painel.cor_primaria">{{
                  senha.senha
                }}</span>
              </div>
              <div
                :style="
                  'font-size: ' +
                  painel.fonte * 0.19 +
                  'vh; line-height: ' +
                  painel.fonte * 0.19 +
                  'vh; font-weight: 500; text-align: center; width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding: 0 0.5vh;'
                "
              >
                {{ senha.local }}
              </div>
              <div
                :style="
                  'font-size: ' +
                  painel.fonte * 0.13 +
                  'vh; line-height: ' +
                  painel.fonte * 0.13 +
                  'vh; font-weight: 400; text-align: center; width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding: 0 0.5vh; margin-top: 0.3vh;'
                "
                v-show="senha.pessoa && painel.mostra_pessoa"
              >
                {{ senha.pessoa }}
              </div>
            </div>
          </div>
          <div
            :class="
              painel.relogio
                ? 'd-flex align-items-center justify-content-center'
                : 'd-none'
            "
            :style="
              'border-radius:' +
              painel.arredondamento +
              'px; width: 10%; height: 14%; background: ' +
              painel.cor_card +
              '; margin-top: 1.5%; flex-direction: column;'
            "
          >
            <span
              :style="
                'font-weight: 700; color:' +
                painel.cor_primaria +
                '; font-size: 1.3vw;'
              "
              >{{ data }}</span
            >
            <span
              :style="
                'font-weight: 700; color:' +
                painel.cor_primaria +
                '; font-size: 1.3vw;'
              "
              >{{ hora }}</span
            >
          </div>
          <div
            :class="
              painel.previsao
                ? 'd-flex align-items-center justify-content-center'
                : 'd-none'
            "
            :style="
              'border-radius:' +
              painel.arredondamento +
              'px; width: 19%; height: 14%; background: ' +
              painel.cor_card +
              '; margin-top: 1.5%; margin-left: ' +
              (painel.relogio ? '1' : '0') +
              '%;'
            "
          >
            <div class="img-lateral" v-show="previsao.id">
              <img
                :src="previsao.icone"
                id="icone"
                alt="icone"
                height="80%"
              /><br />
            </div>
            <div class="texto" v-show="previsao.id">
              <div id="tempo">
                <b>{{ previsao.municipio }}, {{ previsao.data_f }}</b>
              </div>
              <img
                :src="previsao.min_icone"
                alt="img_temp_min"
                id="img_temp_min"
                height="20%"
                class="ml-1"
              />&nbsp; <span id="min">{{ previsao.min }}</span
              ><span class="arial">º</span>
              <img
                :src="previsao.max_icone"
                alt="img_temp_max"
                id="img_temp_max"
                height="20%"
                class="ml-1"
              />&nbsp; <span id="max">{{ previsao.max }}</span
              ><span class="arial">º</span>
              <div class="resumo"></div>
            </div>
          </div>
          <div
            class="d-flex align-items-center justify-content-center"
            :style="
              'overflow: hidden; border-radius:' +
              painel.arredondamento +
              'px; width: ' +
              (100 -
                ((painel.relogio ? 11 : 0) +
                  (painel.previsao ? 20 : 0) +
                  (painel.logo ? 31.5 : 0))) +
              '%; height: 14%; background: ' +
              painel.cor_card +
              '; margin-top: 1.5%; margin-left: ' +
              (painel.relogio + painel.previsao ? '1' : '0') +
              '%;'
            "
          >
            <marquee
              :style="'color:' + painel.cor_primaria + '; font-size: 6vh;'"
              :scrollamount="painel.velocidade_letreiro || 3"
              behavior="scroll"
              direction="left"
              >{{ painel.mensagem }}</marquee
            >
          </div>
          <div
            :class="
              painel.logo
                ? 'd-flex align-items-center justify-content-center'
                : 'd-none'
            "
            :style="
              'border-radius:' +
              painel.arredondamento +
              'px; width: 30%; height: 14%; background: ' +
              painel.cor_card +
              '; margin-top: 1.5%; margin-left: 1.5%;'
            "
          >
            <img :src="painel.logo_f" style="max-height: 90%; max-width: 98%" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="d-flex justify-content-center align-items-center p-1"
      :style="
        'width: 100vw; height: 100vh; background:' +
        painel.background +
        '; flex-direction: column;'
      "
    >
      <h1 :style="'color:' + painel.cor_card">PAINEL INATIVO</h1>
    </div>
  </div>
</template>

<script>
import { BCardText, BLink } from "bootstrap-vue";
import { BCard, BCardBody, BAvatar } from "bootstrap-vue";
import env from "@/config/env.js";

export default {
  data() {
    return {
      video_server_online: true,
      previsao: {},
      detecta_chamada: "",
      chamando: 0,
      speaking: 0,
      painel: {
        ativo: 1,
      },
      configuracao: {},
      data: "",
      hora: "",
      senhas: [],
      vozCarregada: false,
    };
  },
  components: {
    BCard,
    BCardText,
    BLink,
    BCard,
    BCardBody,
    BAvatar,
  },
  methods: {
    downloadVideo() {
      const self = this;
      const api = "http://localhost:3000/video";

      axios
        .post(api, { url: self.painel.video_unidade.video_link })
        .then((response) => {
          console.log("Video baixado com sucesso");
        })
        .catch((error) => {
          self.video_server_online = false;
          self.$message(
            null,
            "Servidor de video offline, utilizando servidor principal",
            "error"
          );
        });
    },
    getPainel: function (id) {
      const self = this;

      var token = self.$store.state.token || localStorage.getItem("token");

      if (!token) {
        console.log("Token não encontrado, fazendo login...");
        self.login();
        return;
      }

      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      const api = self.$store.state.api + `paineis/${id}?with[]=video_unidade`;

      axios
        .get(api)
        .then((response) => {
          self.painel = response.data.data[0];
          self.painel.fonte = parseFloat(self.painel.fonte);
          if (!self.painel.fonte || self.painel.fonte < 5)
            self.painel.fonte = 15;
          console.log("[Painel] fonte recebida da API:", self.painel.fonte);

          if (self.painel.video_unidade) {
            console.log("Baixando video");

            self.downloadVideo();
          } else {
            self.video_server_online = false;
          }

          if (self.painel.previsao) {
            self.getPrevisao();
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            console.log("Token inválido, fazendo login novamente...");
            localStorage.removeItem("token");
            self.login();
          } else {
            self.$message(null, error.response.data, "error");
          }
        });
    },
    getPrevisao: function () {
      const self = this;

      var token = self.$store.state.token || localStorage.getItem("token");
      if (token) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      }

      const api = self.$store.state.api + `previsoes?orderByDesc=id&limit=5`;

      axios
        .get(api)
        .then((response) => {
          self.previsao = response.data.data[0];

          let i = 1;
          var previsao = setInterval(() => {
            self.previsao = response.data.data[i];

            if (i < 4) {
              i++;
            } else {
              i = 0;
            }
          }, 5000);
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.status === 401) {
            console.log("Token inválido em getPrevisao, fazendo login...");
            self.login();
          } else {
            self.$message(
              null,
              "Aguarde 5 minutos e recarregue a página por favor",
              "error"
            );
          }
        });
    },
    getConfiguracao: function () {
      const self = this;

      var token = self.$store.state.token || localStorage.getItem("token");
      if (token) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      }

      const api = self.$store.state.api + "configuracoes/";

      axios
        .get(api)
        .then((response) => {
          self.configuracao = response.data.data[0];
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.status === 401) {
            console.log("Token inválido em getConfiguracao, fazendo login...");
            self.login();
          }
        });
    },
    trataData: function (mes, dia) {
      let mes31 = ["1", "3", "5", "7", "8", "10", "12"];
      let mes30 = ["4", "6", "9", "11"];

      mes = parseInt(mes);
      dia = parseInt(dia);

      let anoAtual = new Date().getFullYear();
      let isBissexto =
        (anoAtual % 4 === 0 && anoAtual % 100 !== 0) || anoAtual % 400 === 0;
      let maxDias = 31;

      if (mes30.includes(mes.toString())) {
        maxDias = 30;
      } else if (mes === 2) {
        maxDias = isBissexto ? 29 : 28;
      }

      if (dia > maxDias) {
        dia = dia - maxDias;
        mes = mes + 1;
      }

      if (mes > 12) {
        mes = 1;
      }

      let diaFormatado = dia < 10 ? "0" + dia : dia.toString();
      let mesFormatado = mes < 10 ? "0" + mes : mes.toString();

      return [diaFormatado, mesFormatado];
    },

    getSenhas: function (id) {
      const self = this;

      // Garantir que o token está configurado
      var token = self.$store.state.token || localStorage.getItem("token");
      if (token) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      }

      const api = self.$store.state.api + "senhas/" + id;

      axios
        .get(api)
        .then((response) => {
          if (response.data.length) {
            self.senhas = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.status === 401) {
            console.log("Token inválido em getSenhas, fazendo login...");
            self.login();
          }
        });
    },
    getWebSocket(id) {
      const self = this;

      setTimeout(function () {
        Echo.private(`painel.${id}`).listen(".PainelEvent", (data) => {
          // Atualiza timestamp da última chamada
          // self.ultimaChamada = Date.now();
          console.log("chamou", data);

          self.waitUntilTrue(data[0]);
        });
      }, 3000);

      setTimeout(function () {
        Echo.private("painel_mensagem." + 1).listen(
          ".PainelMensagemEvent",
          (data) => {
            self.speakText(data.texto);
          }
        );
      }, 3000);
    },
    getHorario: function () {
      const self = this;

      setInterval(() => {
        const date = new Date();
        let ano = date.getFullYear();
        let mes = date.getMonth() + 1;
        let dia = date.getUTCDate();
        let horas = date.getHours();
        let minutos = date.getMinutes();
        let segundos = date.getSeconds();

        self.hora =
          horas.toString().padStart(2, "0") +
          ":" +
          minutos.toString().padStart(2, "0") +
          ":" +
          segundos.toString().padStart(2, "0");
        self.data =
          dia.toString().padStart(2, "0") +
          "/" +
          mes.toString().padStart(2, "0") +
          "/" +
          ano;
      }, 1000);
    },
    async waitUntilTrue(senhaData) {
      while (this.chamando == 1) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      this.chamarSenha(senhaData);
    },
    chamarSenha: function (senhaData) {
      const self = this;
      self.chamando = 1;

      self.senhas.unshift(senhaData);
      if (self.senhas.length >= 4) {
        self.senhas.pop();
      }

      if (self.speaking == 0) {
        // Timer de segurança para timeout (ex: 5 segundos)
        const timeoutLimit = 3000;
        const timeoutId = setTimeout(() => {
          if (self.speaking != 1) {
            self.chamando = 0;
          }
        }, timeoutLimit);
      }

      // Sempre usa o id da rota para salvar
      const painelId =
        this.$route && this.$route.params && this.$route.params.id
          ? this.$route.params.id
          : null;
      if (!painelId) {
        return;
      }
      const storageKey = `data_ultima_chamada_${painelId}`;
      try {
        localStorage.setItem(storageKey, new Date().toISOString());
      } catch (e) {
        try {
          sessionStorage.setItem(storageKey, new Date().toISOString());
        } catch (e2) {}
      }

      if (self.painel.alerta === "alerta_padrao.mp4") {
        $("audio").trigger("play");
        setTimeout(function () {
          self.chamando = 0;
        }, 4500);
      } else {
        $("audio").trigger("play");

        let prefixo = "";
        let senha = "";

        senhaData.prefixo.split("").forEach((prefix) => {
          prefixo += prefix + ", ";
        });

        const digitosSenha = self.configuracao.digitos_senha;
        const senhaCompleta = senhaData.senha;
        const senhaParaFalar =
          digitosSenha && digitosSenha > 0
            ? senhaCompleta.slice(-digitosSenha)
            : senhaCompleta;

        senhaParaFalar.split("").forEach((numero) => {
          senha += numero + ", ";
        });

        window.responsiveVoice.speak(
          "senha, " +
            prefixo +
            senha +
            ", " +
            senhaData.pessoa +
            ", " +
            senhaData.local,
          "Brazilian Portuguese Female",
          {
            onstart: () => {
              console.log("🔊 Fala iniciada");
              this.speaking = true;
              self.chamando = 1;
            },
            onend: () => {
              console.log("✅ Fala finalizada");
              this.speaking = false;
              self.chamando = 0;
            },
            onerror: (e) => {
              console.error("❌ Erro ao falar:", e);
              this.speaking = false;
              self.chamando = 0;
            },
          }
        );

        // self.speakText(
        //   "senha, " +
        //     self.senhas[0].prefixo.split("") +
        //     ", " +
        //     self.senhas[0].senha.split("") +
        //     ", " +
        //     self.senhas[0].pessoa +
        //     ", " +
        //     self.senhas[0].local
        // );
      }

      // const api = this.$store.state.api + "set-alertado/";

      // axios
      //   .post(api, { id: id })
      //   .then((response) => {})
      //   .catch((error) => {
      //     self.$message("Erro", "Erro ao setar o alertado", "error");
      //   });
    },
    // async speakText(text) {
    //   const synth = window.speechSynthesis;
    //   const utterance = new SpeechSynthesisUtterance();
    //   utterance.text = text;
    //   utterance.lang = "pt-BR";
    //   utterance.volume = 1; // volume máximo
    //   utterance.rate = 1; // velocidade normal
    //   utterance.pitch = 1; // tom normal
    //   synth.speak(utterance);
    //   utterance.text = "";
    // },
    login() {
      const self = this;
      const api = this.$store.state.api + "login";
      self.$loading(true);

      axios
        .post(api, {
          login: "sistemas@it4d.com.br",
          password: "SystemPass",
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          window.location.reload();
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message("Erro", error.response.data, "error");
        });
    },
    loadVoice() {
      const script = document.createElement("script");
      script.src =
        "https://code.responsivevoice.org/responsivevoice.js?key=vxZsk5jt";
      script.async = true;
      script.onload = () => {
        this.vozCarregada = true;
      };
      script.onerror = () => {
        console.error("Erro ao carregar o script responsiveVoice.");
      };
      document.head.appendChild(script);
    },
    verificarInatividade() {
      const tempoMinutos = env.painelInatividade || 5;

      const painelId =
        this.$route && this.$route.params && this.$route.params.id;
      const storageKey = `data_ultima_chamada_${painelId}`;
      let ultimaChamadaStr =
        localStorage.getItem(storageKey) || sessionStorage.getItem(storageKey);

      if (!ultimaChamadaStr) return;

      const agora = Date.now();
      const ultimaChamada = new Date(ultimaChamadaStr).getTime();
      const diferenca = agora - ultimaChamada;
      const tempoMs = tempoMinutos * 60 * 1000;

      if (diferenca >= tempoMs) {
        console.log(
          "Painel inativo por " + tempoMinutos + " minutos. Recarregando..."
        );
        window.location.reload();
      }
    },
  },
  mounted() {
    const self = this;
    let id = self.$route.params.id;

    let array = {
      id: null,
      prefixo: "-",
      senha: "----",
      local: "-",
    };

    for (let i = 0; i < 4; i++) {
      self.senhas.push(array);
    }

    self.getHorario();

    if (id) {
      self.getPainel(id);
      self.getConfiguracao();

      self.getSenhas(id);
      self.getWebSocket(id);

      self.loadVoice();

      setInterval(() => {
        self.getPainel(id);
      }, 600000);

      // Verifica inatividade a cada intervalo definido no env.js (default: 5 minutos)
      const tempoVerificacao = (env.painelInatividade || 5) * 60 * 1000;
      setInterval(() => {
        self.verificarInatividade();
      }, tempoVerificacao);
    }
  },
  created() {},
};
</script>
<style>
html,
body {
  font-family: helvetica;
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
.fadeIn {
  -webkit-animation: fadeIn 1.3s ease-in-out;
  -moz-animation: fadeIn 1.3s ease-in-out;
  -o-animation: fadeIn 1.3s ease-in-out;
  animation: fadeIn 1.3s ease-in-out;
}
body {
  overflow-x: hidden;
}
#mensagens-container {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* Começa à esquerda */
  overflow: hidden; /* Esconde conteúdo fora da área visível */
  width: 100%; /* Ocupa toda a largura do container */
  height: 100%; /* Ocupa toda a altura do container */
}
#mensagens {
  display: inline-block;
  white-space: nowrap; /* Garante que o texto fique em linha única */
  animation: marquee 20s linear infinite; /* Define a animação contínua */
  padding-left: 100%; /* Garante que o texto comece fora da área visível */
}
@keyframes marquee {
  from {
    transform: translateX(10%); /* Inicia na posição atual */
  }
  to {
    transform: translateX(-100%); /* Termina fora da área visível à esquerda */
  }
}
</style>
